import React from "react";
import { Box, Typography, Button } from "@mui/material";

const Viajes = ({ trips, visibleTrips, toggleTrip }) => {
    return (
        <Box
            sx={{
                width: 280,
                borderRight: "1px solid #E5E7EB",
                background: "#F8FAFC",
                display: "flex",
                flexDirection: "column",
                minHeight: 0
            }}
        >
            {/* HEADER */}
            <Box
                sx={{
                    px: 2.5,
                    py: 2,
                    borderBottom: "1px solid #E5E7EB"
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 13,
                        letterSpacing: 1,
                        color: "#64748B",
                        textTransform: "uppercase"
                    }}
                >
                    Viajes del día
                </Typography>
            </Box>

            {/* LISTA */}
            <Box
                sx={{
                    overflowY: "auto",
                    flex: 1,
                    px: 1.5,
                    py: 1.5
                }}
            >
                {trips.map((trip, index) => {
                    const activo = visibleTrips.has(index);

                    return (
                        <Box
                            key={index}
                            sx={{
                                mb: 1.2,
                                p: 1.5,
                                borderRadius: "12px",
                                background: "#FFFFFF",
                                border: "1px solid #E5E7EB",
                                display: "flex",
                                flexDirection: "column",
                                gap: 0.5,
                                transition: "all .2s",
                                "&:hover": {
                                    boxShadow: 2,
                                    transform: "translateY(-1px)"
                                },
                                ...(activo && {
                                    borderLeft: "4px solid #2FA4B8"
                                })
                            }}
                        >
                            {/* TITULO */}
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: 13,
                                    color: "#0F172A"
                                }}
                            >
                                🚗 Viaje {index + 1}
                            </Typography>

                            {/* HORARIO */}
                            <Typography
                                sx={{
                                    fontSize: 11,
                                    color: "#64748B"
                                }}
                            >
                                {new Date(trip.start_time).toLocaleTimeString()}
                                {" → "}
                                {new Date(trip.end_time).toLocaleTimeString()}
                            </Typography>

                            {/* METRICAS */}
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 1.2,
                                    fontSize: 11,
                                    color: "#334155"
                                }}
                            >
                                <span>📏 {trip.distance_km} km</span>
                                <span>⏱ {trip.duration_min} min</span>
                                {/*<span>⚡ {trip.avg_speed} km/h</span>*/}

                                <span
                                    style={{
                                        color: trip.max_speed > 100 ? "#D32F2F" : "#334155",
                                        fontWeight: trip.max_speed > 100 ? 600 : 400
                                    }}
                                >
                                    🚀 {trip.max_speed} km/h
                                </span>
                            </Box>

                            {/* 🛑 NUEVO: PARADAS */}
                            {trip.stops?.length > 0 && (
                                <Typography
                                    sx={{
                                        fontSize: 11,
                                        color: "#D84315",
                                        fontWeight: 600
                                    }}
                                >
                                    🛑 {trip.stops.length} parada{trip.stops.length > 1 ? "s" : ""}
                                </Typography>
                            )}

                            {/* BOTON */}
                            <Button
                                size="small"
                                variant={activo ? "contained" : "outlined"}
                                onClick={() => toggleTrip(index)}
                                fullWidth
                                sx={{
                                    mt: 0.8,
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    fontSize: 12,
                                    ...(activo
                                        ? {
                                            backgroundColor: "#2FA4B8",
                                            "&:hover": { backgroundColor: "#258a9c" }
                                        }
                                        : {
                                            borderColor: "#2FA4B8",
                                            color: "#2FA4B8"
                                        })
                                }}
                            >
                                {activo ? "Visible en mapa" : "Mostrar en mapa"}
                            </Button>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default Viajes;